module.exports = __webpack_public_path__ + "static/img/cultural_background.e273b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/cultural_background.png
// module id = G+hL
// module chunks = 0